var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"item-text":"name","prepend-icon":"credit_card","items":_vm.permissions,"return-object":true,"value":_vm.selectedItem,"label":'Valitse kuljetuspäätös'},on:{"input":_vm.selectPermission}})}
var staticRenderFns = []

export { render, staticRenderFns }